"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var reset_school_service_area_modal_html_1 = __importDefault(require("./reset-school-service-area-modal/reset-school-service-area-modal.html"));
var AdminServiceAreaController = /** @class */ (function () {
    function AdminServiceAreaController($scope, $state, $stateParams, $uibModal, SchoolsModel, ZonesModel, FlashService, VueStoreFactory) {
        this.openingResetModal = false;
        this.$scope = $scope;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$uibModal = $uibModal;
        this.SchoolsModel = SchoolsModel;
        this.ZonesModel = ZonesModel;
        this.FlashService = FlashService;
        this.VueStoreFactory = VueStoreFactory;
        this.loading = true;
        this.loadSchoolData();
        // Bind methods to preserve 'this' context
        this.onFeatureSelect = this.onFeatureSelect.bind(this);
        this.onServiceAreaSaved = this.onServiceAreaSaved.bind(this);
        this.onServiceAreaError = this.onServiceAreaError.bind(this);
    }
    AdminServiceAreaController.prototype.openResetPlacementsModal = function () {
        var _this = this;
        if (this.openingResetModal || !this.school) {
            return;
        }
        this.openingResetModal = true;
        this.ZonesModel.getZones()
            .then(function (response) {
            var modal = _this.$uibModal.open({
                template: reset_school_service_area_modal_html_1.default,
                controller: "ResetSchoolServiceAreaModalController",
                controllerAs: "vm",
                backdrop: "static",
                keyboard: false,
                resolve: {
                    school: function () { return _this.school; },
                    zones: function () { return response.zones || []; },
                },
            });
            modal.result.then(function (result) {
                if (result && result.status === "completed") {
                    var failedSuffix = result.failed && result.failed > 0
                        ? " (".concat(result.failed, " failed and will retry on the queue)")
                        : "";
                    _this.FlashService.setMessage({
                        type: "success",
                        message: "Re-placed ".concat(result.processed, " student(s)").concat(failedSuffix, "."),
                    });
                }
                else if (result && result.status === "running") {
                    _this.FlashService.setMessage({
                        type: "success",
                        message: "Reset is running in the background. You can come back to this screen later.",
                    });
                }
            }, function () {
                // Dismissed; no toast needed.
            });
        })
            .catch(function () {
            _this.FlashService.setMessage({
                type: "error",
                message: "Failed to load zones for this school.",
            });
        })
            .finally(function () {
            _this.openingResetModal = false;
        });
    };
    AdminServiceAreaController.prototype.loadSchoolData = function () {
        var _this = this;
        var schoolId = this.$stateParams.schoolId;
        if (!schoolId) {
            this.FlashService.setMessage({
                type: "error",
                message: "School ID is required",
            });
            return;
        }
        this.SchoolsModel.getSchoolByID(schoolId)
            .then(function (school) {
            _this.school = school;
            _this.loading = false;
        })
            .catch(function (error) {
            _this.FlashService.setMessage({
                type: "error",
                message: "Failed to load school data",
            });
            _this.loading = false;
        });
    };
    AdminServiceAreaController.prototype.onServiceAreaSaved = function () {
        this.FlashService.setMessage({
            type: "success",
            message: "Service area saved successfully",
        });
    };
    AdminServiceAreaController.prototype.onServiceAreaError = function (error) {
        this.FlashService.setMessage({
            type: "error",
            message: error || "Failed to save service area",
        });
    };
    AdminServiceAreaController.prototype.onFeatureSelect = function (feature) {
        // Handle feature selection from the zone parts list
        this.VueStoreFactory.dispatch("serviceAreas/selectFeature", feature);
    };
    return AdminServiceAreaController;
}());
AdminServiceAreaController.$inject = [
    "$scope",
    "$state",
    "$stateParams",
    "$uibModal",
    "SchoolsModel",
    "ZonesModel",
    "FlashService",
    "VueStoreFactory",
];
exports.default = AdminServiceAreaController;
